export const openLinkInNewTab = (link: string): Window | null => {
  const win = window.open(link, '_blank');
  if (win) win.focus();
  return win;
};

export const openLinkInSameTab = (link) => {
  window.location.assign(link);
};

// this is a convenience for creating a window reference on click
// so we can pass it to async functions like label regen
// because iOS safari won't open window refs that are created async
// for more info: https://stackoverflow.com/a/39387533/14102530
//
// There is some kind of issue with this and Firefox where it will throw an `Error: Should not already be working`.
// The try/catch attempts to handle that and other errors that we're not ready for.
// It's the caller's responsibility to handle the condition where a new window cannot be opened!
export const createWindowRef = (loadingState: string) => {
  try {
    const windowRef = window.open('', '_blank');
    if (!windowRef) return null;

    const metaTag = windowRef.document.createElement('meta');
    metaTag['name'] = 'viewport';
    metaTag['content'] = 'width=device-width, initial-scale=1';
    windowRef.document.getElementsByTagName('head')[0].appendChild(metaTag);

    windowRef.document.body.innerHTML = loadingState;

    return windowRef;
  } catch (_) {
    return null;
  }
};
